import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Card, CardBody, Button, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { capitalizeFirstLetter } from '../../../../util/text';

import { getLanguagePath } from '../../../Intl/IntlActions';

import { getCartItems, getCartSubscription, removeCartSubscription } from '../../CartActions';

import FontCustom from '../../../../components/Content/FontCustom';

import CartItem from '../item/CartItem';
import CartTotals from './CartTotals';
import ShippingCalculator from '../../../ShippingFee/components/calculate/ShippingCalculator';
import VoucherApplyForm from '../../../Voucher/components/apply/VoucherApplyForm';


class CartPreview extends Component {
    // constructor(props) {
    //     super(props);
    //
    //     this.state = {
    //     };
    // }

    handleRemoveSubscription = () => {
        this.props.dispatch(removeCartSubscription());
    }


    render() {
        const { items, subscription } = this.props;
        if(items && items.length) {
            return (
                <Fragment>
                    <Card>
                        <CardBody>
                            <div className="my-3 py-3 border-bottom-tertiary">
                                {items.map((item, index) => <CartItem key={item.productId || index} item={item} locale={this.props.intl.locale} />)}
                            </div>

                            <div className="my-3 py-3 border-bottom-tertiary">
                                <ShippingCalculator locale={this.props.intl.locale} />
                            </div>

                            <div className="my-3 py-3 border-bottom-tertiary">
                                <VoucherApplyForm locale={this.props.intl.locale} />
                            </div>

                            <div className="my-3 py-3">
                                <CartTotals locale={this.props.intl.locale} />
                            </div>

                            <div className="my-3 py-3 d-flex justify-content-center">
                                <Button color="light" size="lg" tag={Link} to={getLanguagePath('/product', this.props.intl.locale)} className="mr-2"><FormattedMessage id="back" defaultMessage="Back" /></Button>
                                <Button color="warning" size="lg" onClick={this.props.goToNextStep}><FormattedMessage id="cartNextButton" defaultMessage="Next" /></Button>
                            </div>

                            <div className="text-center text-primary">
                                <FontCustom name="secure" size="2" className="text-secondary" /> <FormattedMessage id="appAdvantagesSecurePayment" defaultMessage="Secure payment" />
                            </div>
                        </CardBody>
                    </Card>

                    {
                        subscription
                        ? (
                            <Card className="mt-3 bg-tertiary text-center">
                                <CardBody>
                                    <h3><FormattedMessage id="subscriptionResumeTitle" defaultMessage="Your subscription" /></h3>
                                    <p>
                                        <FormattedMessage
                                            id="subscriptionResumeText"
                                            defaultMessage="You choose to subscribe to {count} bottle(s) every {period}"
                                            values={{
                                                count: items.reduce((total, item) => total + item.quantity + (item.freeCount || 0), 0),
                                                period: this.props.intl.formatMessage({
                                                    id: `subscriptionPeriod${subscription.periodIntervalValue}${capitalizeFirstLetter(subscription.periodIntervalUnit)}`,
                                                    defaultMessage: `${subscription.periodIntervalValue} ${subscription.periodIntervalUnit}(s)`,
                                                }),
                                            }}
                                        />
                                        <br />
                                        <Button color="link" size="sm" tag={Link} to={getLanguagePath('/subscribe', this.props.intl.locale)}><small><FontAwesome name="pen" /> <FormattedMessage id="edit" defaultMessage="Edit" /></small></Button>
                                        <Button color="link" size="sm" onClick={this.handleRemoveSubscription}><small><FontAwesome name="times" /> <FormattedMessage id="subscriptionRemoveButton" defaultMessage="I do not want to subscribe for now" /></small></Button>
                                    </p>
                                </CardBody>
                            </Card>
                        )
                        : (
                            <div className="mt-2 text-right text-uppercase">
                                {false && <Link to={getLanguagePath('/subscribe', this.props.intl.locale)}><FormattedMessage id="subscriptionCartButton" defaultMessage="I subscribe without obligation" /> <FontAwesome name="chevron-right" /></Link>}
                            </div>
                        )
                    }
                </Fragment>
            );
        }
        return (
            <Alert color="warning" className="text-center">
                <FontAwesome name="exclamation-circle" /> <FormattedMessage id="cartEmptyError" defaultMessage="Your cart is empty..." />
            </Alert>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        items: getCartItems(store),
        subscription: getCartSubscription(store),
    };
}

CartPreview.defaultProps = {
    items: [],
    subscription: null,
};

CartPreview.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    items: PropTypes.arrayOf(PropTypes.object),
    subscription: PropTypes.object,
    goToNextStep: PropTypes.func.isRequired,
};


export default connect(mapStateToProps)(injectIntl(CartPreview));
